export default __webpack_public_path__ + "static/media/relogin.24b9cd09.png";